'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', ';\n'], ['\n  background: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('@hixme-ui/theme');

var _themeProps = require('@hixme-ui/theme-props');

var _getMargin = require('./utils/getMargin');

var _getMargin2 = _interopRequireDefault(_getMargin);

var _getPadding = require('./utils/getPadding');

var _getPadding2 = _interopRequireDefault(_getPadding);

var _getBorder = require('./utils/getBorder');

var _getBorder2 = _interopRequireDefault(_getBorder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flexKeys = ['flex', 'inlineFlex', 'flexRow', 'flexColumn', 'flexBasis', 'flexGrow', 'flexShrink'];
var isFlex = function isFlex(props) {
  return (0, _keys2.default)(props).filter(function (prop) {
    return flexKeys.includes(prop) && props[prop];
  }).length > 0;
};
var getFlexProps = function getFlexProps(props) {
  if (isFlex(props)) {
    var output = props.inlineFlex ? 'display: inline-flex;' : 'display: flex;';

    if (props.flexWrap) output += 'flex-wrap: wrap;';

    // Flex Direction
    if (props.flexRow) output += 'flex-direction: row;';
    if (props.flexColumn) output += 'flex-direction: column;';

    // Justify Content - booleans
    if (props.justifyStart) output += 'justify-content: flex-start;';
    if (props.justifyEnd) output += 'justify-content: flex-end;';
    if (props.justifyCenter) output += 'justify-content: center;';
    if (props.justifySpaceBetween) output += 'justify-content: space-between;';
    if (props.justifySpaceAround) output += 'justify-content: space-around;';

    // Align Items - booleans
    if (props.alignStart) output += 'align-items: flex-start;';
    if (props.alignEnd) output += 'align-items: flex-end;';
    if (props.alignCenter) output += 'align-items: center;';
    if (props.alignSpaceBetween) output += 'align-items: space-between;';
    if (props.alignSpaceAround) output += 'align-items: space-around;';

    // Flex settings - strings
    if (props.direction) output += 'flex-direction: ' + props.direction + ';';
    if (props.alignItems) output += 'align-items: ' + props.alignItems + ';';
    if (props.alignContent) output += 'align-content: ' + props.alignContent + ';';
    if (props.justifyContent) output += 'justify-content: ' + props.justifyContent + ';';
    if (props.alignSelf) output += 'align-self: ' + props.alignSelf + ';';
    if (props.flexBasis) output += 'flex-basis: ' + props.flexBasis + ';';
    if (props.flexGrow) output += 'flex-grow: ' + props.flexGrow + ';';
    if (props.flexShrink) output += 'flex-shrink: ' + props.flexShrink + ';';

    return output;
  }
  return '';
};

var getAnimate = function getAnimate(_ref) {
  var animate = _ref.animate,
      heavyShadow = _ref.heavyShadow;

  if (animate) {
    var hoverShadow = heavyShadow ? '0px 6px 16px 0px ' + _theme.colors.grey100 : '0px 6px 9px 0px ' + _theme.colors.grey120;
    return 'transition: box-shadow .2s ease-in-out;\n            &:hover { box-shadow: ' + hoverShadow + '; };';
  }
  return '';
};

var getTextAlign = function getTextAlign(_ref2) {
  var textAlign = _ref2.textAlign,
      textLeft = _ref2.textLeft,
      textCenter = _ref2.textCenter,
      textRight = _ref2.textRight;

  if (textLeft) return 'text-align: left;';
  if (textCenter) return 'text-align: center;';
  if (textRight) return 'text-align: right;';
  if (textAlign) return 'text-align: ' + textAlign + ';';
  return '';
};

var ContainerBase = _styledComponents2.default.div(_templateObject, function (props) {
  if (props.background) return props.background;
  return (0, _themeProps.getBackgroundColor)(props, 'none');
}, getTextAlign, getFlexProps, function (_ref3) {
  var width = _ref3.width;
  return width && 'width: ' + width + ';';
}, function (_ref4) {
  var height = _ref4.height;
  return height && 'height: ' + height + ';';
}, function (_ref5) {
  var maxWidth = _ref5.maxWidth;
  return maxWidth && 'max-width: ' + maxWidth + ';';
}, function (_ref6) {
  var maxHeight = _ref6.maxHeight;
  return maxHeight && 'max-height: ' + maxHeight + ';';
}, function (_ref7) {
  var minWidth = _ref7.minWidth;
  return minWidth && 'min-width: ' + minWidth + ';';
}, function (_ref8) {
  var minHeight = _ref8.minHeight;
  return minHeight && 'min-height: ' + minHeight + ';';
}, function (_ref9) {
  var noPadding = _ref9.noPadding,
      props = (0, _objectWithoutProperties3.default)(_ref9, ['noPadding']);
  return noPadding ? 'padding: 0;' : (0, _getPadding2.default)(props);
}, _getMargin2.default, _getBorder2.default, function (_ref10) {
  var dashed = _ref10.dashed;
  return dashed && 'border: 2px dashed;';
}, function (_ref11) {
  var rounded = _ref11.rounded;
  return rounded && 'border-radius: 6px;';
}, function (_ref12) {
  var shadow = _ref12.shadow;
  return shadow && 'box-shadow: 0 3px 3px ' + _theme.colors.grey120 + ';';
}, function (_ref13) {
  var opacity = _ref13.opacity;
  return opacity && 'opacity: ' + opacity + ';';
}, function (_ref14) {
  var heavyShadow = _ref14.heavyShadow;
  return heavyShadow && 'box-shadow: 0px 3px 10px 0px ' + _theme.colors.grey100 + ';';
}, function (_ref15) {
  var withOutline = _ref15.withOutline;
  return withOutline && 'outline: 1px solid red;';
}, getAnimate);

ContainerBase.displayName = 'hui:ContainerBase';
ContainerBase.huiName = 'ContainerBase';

exports.default = ContainerBase;
//# sourceMappingURL=ContainerBase.js.map


//////////////////
// WEBPACK FOOTER
// ../container/lib/ContainerBase.js
// module id = 119
// module chunks = 0